import { render, staticRenderFns } from "./rule-summary.vue?vue&type=template&id=4afffa74&"
import script from "./rule-summary.vue?vue&type=script&lang=js&"
export * from "./rule-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports